export enum BotKind {
  NONE = 'NONE',
  // BOT_ONE = 'BOT_ONE',
  // BOT_TWO = 'BOT_TWO',
  // BOT_THREE = 'BOT_THREE',
  BOT_PP = 'BOT_PP'
}
